/** 6 碼兌換編號（與後端 coupon-claim-lib 一致） */
export function formatRedeemDisplayCode(claimId) {
  const id = Number(claimId);
  if (!Number.isFinite(id) || id < 0) return '';
  return String(id).padStart(6, '0');
}

function parseLegacyRedeemDisplayCode5(code) {
  const s = String(code || '').trim();
  if (!/^\d{5}$/.test(s)) return null;
  const claimId = parseInt(s.slice(1, 4), 10);
  if (!claimId) return null;
  if (Math.floor(claimId / 10) !== Number(s[0])) return null;
  if (claimId % 10 !== Number(s[4])) return null;
  return claimId;
}

export function parseRedeemDisplayCode(code) {
  const s = String(code || '').trim();
  if (!/^\d+$/.test(s)) return null;
  if (/^\d{6}$/.test(s)) {
    const id = parseInt(s, 10);
    return id > 0 ? id : null;
  }
  return parseLegacyRedeemDisplayCode5(s);
}

export function resolveDisplayCode(claimId, displayCode) {
  return displayCode || formatRedeemDisplayCode(claimId);
}
